import { useState } from "react";
import Link from "next/link";
import base from "lib/base";
import styles from "./PodcastCard.module.css";

const PodcastIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16.85 18.58a9 9 0 1 0-9.7 0" />
    <path d="M8 14a5 5 0 1 1 8 0" />
    <circle cx="12" cy="11" r="1" />
    <path d="M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z" />
  </svg>
);

const ArrowDownIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 5v14" />
    <path d="m19 12-7 7-7-7" />
  </svg>
);

const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]+>/g, "");
};

export default function PodcastCard({ podcast }) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const cdnBase = String(base.cdnUrl || "").replace(/\/+$/, "");

  const imageUrl = podcast.pictures?.[0]
    ? podcast.pictures[0].startsWith("http")
      ? podcast.pictures[0]
      : `${cdnBase}/450/${String(podcast.pictures[0]).replace(/^\/+/, "")}`
    : "/images/placeholder.jpg";

  const canOpenDetail = Boolean(podcast?.isMore && podcast?.slug);

  const handleCardClick = () => {
    if (canOpenDetail) return;
    setShowOverlay(true);
    setIsClosing(false);
  };

  const handleCloseOverlay = (e) => {
    e.stopPropagation();
    setIsClosing(true);
    setTimeout(() => {
      setShowOverlay(false);
      setIsClosing(false);
    }, 300);
  };

  const cardContent = (
    <>
      <div className={styles.imageWrapper}>
        <img
          src={imageUrl}
          alt={podcast.name}
          className={styles.image}
          loading="lazy"
          decoding="async"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{podcast.name}</h3>
        <p className={styles.description}>{stripHtml(podcast.details)}</p>
      </div>
      <div className={styles.footer}>
        <div className={styles.listenBtn}>
          <span>{canOpenDetail ? "Дэлгэрэнгүй" : "Сонсох"}</span>
          <PodcastIcon />
        </div>
      </div>

      {showOverlay && (
        <div className={styles.overlay} onClick={handleCloseOverlay}>
          <div
            className={`${styles.overlayContent} ${isClosing ? styles.closing : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button className={styles.closeButton} onClick={handleCloseOverlay}>
              <ArrowDownIcon />
            </button>

            <div className={styles.overlayHeader}>
              <div className={styles.overlayTitle}>Сувгууд</div>
            </div>

            <div className={styles.linksList}>
              {podcast.links && podcast.links.length > 0 ? (
                podcast.links.map((link) => (
                  <a
                    key={link._id || link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.linkItem}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {link.name}
                  </a>
                ))
              ) : (
                <p className={styles.noLinks}>Холбоос байхгүй байна.</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );

  if (canOpenDetail) {
    return (
      <Link href={`/podcast/${podcast.slug}`} className={styles.cardLink}>
        <div className={styles.card}>{cardContent}</div>
      </Link>
    );
  }

  return (
    <div
      className={styles.card}
      onClick={handleCardClick}
      style={{ cursor: "pointer" }}
    >
      {cardContent}
    </div>
  );
}
